"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableModels = getAvailableModels;
exports.parseWatchFaceBin = parseWatchFaceBin;
exports.writeWatchFaceBin = writeWatchFaceBin;

var _parametersParser = require("./parametersParser");

var _imageParser = require("./imageParser");

var _compressedFilesUtils = require("./compressedFilesUtils");

var _UIHH_MIBAND = _interopRequireDefault(require("./models/fileTypes/UIHH_MIBAND.json"));

var _HMDIAL_GT = _interopRequireDefault(require("./models/fileTypes/HMDIAL_GT.json"));

var _UIHH_GT = _interopRequireDefault(require("./models/fileTypes/UIHH_GT2.json"));

var _UIHH_BIPU_GTS2MINI = _interopRequireDefault(require("./models/fileTypes/UIHH_BIPU_GTS2MINI.json"));

var _miband = _interopRequireDefault(require("./models/miband4.json"));

var _miband2 = _interopRequireDefault(require("./models/miband5.json"));

var _miband3 = _interopRequireDefault(require("./models/miband6.json"));

var _amazfitbip = _interopRequireDefault(require("./models/amazfitbip.json"));

var _amazfitbips = _interopRequireDefault(require("./models/amazfitbips.json"));

var _amazfitbipu = _interopRequireDefault(require("./models/amazfitbipu.json"));

var _amazfitgtr = _interopRequireDefault(require("./models/amazfitgtr42.json"));

var _amazfitgtr2 = _interopRequireDefault(require("./models/amazfitgtr47.json"));

var _amazfitgtr3 = _interopRequireDefault(require("./models/amazfitgtr2.json"));

var _amazfitgts = _interopRequireDefault(require("./models/amazfitgts.json"));

var _amazfitgts2 = _interopRequireDefault(require("./models/amazfitgts2.json"));

var _amazfitgts2mini = _interopRequireDefault(require("./models/amazfitgts2mini.json"));

var _amazfittrex = _interopRequireDefault(require("./models/amazfittrex.json"));

var _amazfittrexpro = _interopRequireDefault(require("./models/amazfittrexpro.json"));

var _amazfitx = _interopRequireDefault(require("./models/amazfitx.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var fileTypes = {
  UIHH_MIBAND: _UIHH_MIBAND["default"],
  HMDIAL_GT: _HMDIAL_GT["default"],
  UIHH_GT2: _UIHH_GT["default"],
  UIHH_BIPU_GTS2MINI: _UIHH_BIPU_GTS2MINI["default"]
};
var watchModelsDescriptor = [_miband3["default"], _miband2["default"], _miband["default"], _amazfitx["default"], _amazfittrexpro["default"], _amazfittrex["default"], _amazfitgts2mini["default"], _amazfitgts2["default"], _amazfitgts["default"], _amazfitgtr3["default"], _amazfitgtr["default"], _amazfitgtr2["default"], _amazfitbip["default"], _amazfitbips["default"], _amazfitbipu["default"]];

function getAvailableModels() {
  var _iterator = _createForOfIteratorHelper(watchModelsDescriptor),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var model = _step.value;
      if (typeof model.fileType === "string") // Replace file type name with actual fileType data
        model.fileType = fileTypes[model.fileType];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return watchModelsDescriptor;
}
/**
 * Parse a watchface bin file parameters and images
 * @param {ArrayBuffer} buffer An arrayBuffer of a watchface bin file
 * @param {object} fileStructureInfo A file structure descriptor for this bin format
 * @returns {{parameters: object, images: object[]}} An object containing the parameters and images found in the file
 */


function parseWatchFaceBin(buffer, fileStructureInfo) {
  // Check is file is compressed and needs to be uncompressed
  if (fileStructureInfo.compressionStart != null) {
    if ([0x4F, 0x4E].includes(new DataView(buffer, fileStructureInfo.compressionStart, 1).getUint8(0))) {
      buffer = new Uint8Array((0, _compressedFilesUtils.uncompressFile)(buffer, fileStructureInfo.compressionStart)).buffer;
    }
  }

  var headerSize = fileStructureInfo.header.length;
  var offset = 0; // Read header

  var header = new DataView(buffer, offset, headerSize); // Offset is now at parametersInfo

  offset += headerSize; // Check signature

  var fileSignature = Array.from(new Uint8Array(buffer, 0, fileStructureInfo.signatureSize));
  var expectedSignature = fileStructureInfo.header.slice(0, fileStructureInfo.signatureSize);

  if (JSON.stringify(fileSignature) !== JSON.stringify(expectedSignature)) {
    throw new Error("Invalid file signature, expected ".concat(expectedSignature, " but found ").concat(fileSignature));
  }

  var parameterBufferSizePosition = fileStructureInfo.parameterBufferSizePosition || headerSize - 0x8;
  var parametersInfoSizePosition = fileStructureInfo.parametersInfoSizePosition || headerSize - 0x4; // Size of the biggest paramater
  // Parameters with a size bigger than this will be ignored by the watch

  var parameterBufferSize = header.getUint32(parameterBufferSizePosition, true);
  var parametersInfoSize = header.getUint32(parametersInfoSizePosition, true); // console.debug(`Read parameters info ${parameterBufferSize}:${parametersInfoSize}`)
  // Read parameters info

  var parametersInfo = (0, _parametersParser.parseParameters)(new Uint8Array(buffer, offset, parametersInfoSize), fileStructureInfo.valueBitSize); // Offset is now at parameters

  offset += parametersInfoSize; // First parameter info contains parameters size and images count

  var parametersSize = parametersInfo["1"]["1"];
  var imagesCount = parametersInfo["1"]["2"];
  delete parametersInfo["1"]; // Other parameter info contain location of each parameters

  var parameters = {};

  for (var _i = 0, _Object$entries = Object.entries(parametersInfo); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    var parameterOffset = value["1"] || 0;
    var parameterSize = value["2"]; // console.debug(`Read parameter ${key}, ${parameterOffset}:${parameterSize}`)

    parameters[key] = (0, _parametersParser.parseParameters)(new Uint8Array(buffer, offset + parameterOffset, parameterSize), fileStructureInfo.valueBitSize);
  } // convert parameter ids to readable names


  var parametersWithName = (0, _parametersParser.convertIdsToNames)(parameters, fileStructureInfo); // Offset is now at images info

  offset += parametersSize;
  var imageCountOffset = fileStructureInfo.imageCountOffset || 0;
  imagesCount -= imageCountOffset;
  var imagesInfoSize = 4 * imagesCount;
  var imagesInfo = new DataView(buffer, offset, imagesInfoSize); // Offset is now at images

  offset += imagesInfoSize; // Load each image 

  var images = [];

  for (var i = 0; i < imagesCount; i++) {
    var imageOffset = imagesInfo.getUint32(i * 4, true);
    images.push((0, _imageParser.parseImage)(buffer.slice(offset + imageOffset)));
  }

  return {
    parameters: parametersWithName,
    images: images
  };
}
/**
 * Write a watchface bin file parameters and images
 * 
 * @param {object} parameters parameters object with name as key
 * @param {object[]} images list of resource images to include
 * @param {object} fileStructureInfo A file structure descriptor for this bin format
 * @returns {Uint8Array} The binary data of the resulting watchface file
 */


function writeWatchFaceBin(parametersWithNames, images, fileStructureInfo) {
  // Convert parameters names to ids
  var parametersWithIds = (0, _parametersParser.convertNamesToIds)(parametersWithNames, fileStructureInfo); // Encode all the parameters

  var parametersInfo = {
    "1": {
      "1": 0,
      "2": images.length
    }
  };
  var binaryParameters = [];
  var maxParameterLength = 0;

  for (var _i2 = 0, _Object$entries2 = Object.entries(parametersWithIds); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    // Encode parameter to binary
    var binaryParameter = (0, _parametersParser.writeParameters)(value, fileStructureInfo.valueBitSize); // write postion and offset in parameters info

    parametersInfo[key] = {
      "1": binaryParameters.length,
      "2": binaryParameter.length
    }; // write actual parameter

    binaryParameters.push.apply(binaryParameters, _toConsumableArray(binaryParameter));

    if (binaryParameter.length > maxParameterLength) {
      maxParameterLength = binaryParameter.length;
    }
  } // write parameters size in param info


  parametersInfo["1"]["1"] = binaryParameters.length; // Encode parameters info

  var binaryParametersInfo = (0, _parametersParser.writeParameters)(parametersInfo, fileStructureInfo.valueBitSize);
  var binaryImagesInfo = new Uint8Array(images.length * 4);
  var binaryImagesInfoView = new DataView(binaryImagesInfo.buffer);
  var binaryImages = [];
  var imagesSize = 0; // Encode each image

  var _iterator2 = _createForOfIteratorHelper(images.entries()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          i = _step2$value[0],
          image = _step2$value[1];

      // write offset of image in image info
      binaryImagesInfoView.setUint32(i * 4, imagesSize, true); // convert image to bitmap file

      var _binaryImage = new Uint8Array((0, _imageParser.writeImage)(image.pixels, image.width, image.height));

      binaryImages.push(_binaryImage);
      imagesSize += _binaryImage.length;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var headerSize = fileStructureInfo.header.length; // Create buffer to hold file data

  var result = new Uint8Array(headerSize + binaryParametersInfo.length + binaryParameters.length + binaryImagesInfo.length + imagesSize);
  var resultView = new DataView(result.buffer); // write header

  result.set(fileStructureInfo.header, 0); // Set parameters info size

  var parameterBufferSizePosition = fileStructureInfo.parameterBufferSizePosition || headerSize - 0x8;
  var parametersInfoSizePosition = fileStructureInfo.parametersInfoSizePosition || headerSize - 0x4;
  resultView.setUint32(parameterBufferSizePosition, maxParameterLength, true);
  resultView.setUint32(parametersInfoSizePosition, binaryParametersInfo.length, true);
  var offset = headerSize; // add parameters info

  result.set(binaryParametersInfo, offset);
  offset += binaryParametersInfo.length; // add parameters

  result.set(binaryParameters, offset);
  offset += binaryParameters.length; // add images info

  result.set(binaryImagesInfo, offset);
  offset += binaryImagesInfo.length; //add images

  for (var _i3 = 0, _binaryImages = binaryImages; _i3 < _binaryImages.length; _i3++) {
    var binaryImage = _binaryImages[_i3];
    result.set(binaryImage, offset);
    offset += binaryImage.length;
  }

  return result;
}